import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { FormInput } from '@podiumhq/podium-ui';

import usePostalCodeInput from './hooks/usePostalCodeInput';

import {
  CARD_ID,
  EXPIRATION_DATE_ID,
  POSTAL_CODE_ID,
  SECURITY_CODE_ID,
} from './constants';
import CreditCardDetailsInput from './CreditCardDetailsInput';
import useStripeInputProps from './hooks/useStripeInputProps';
import {
  CreditCardDetailsHeader,
  CreditCardDetailsRow,
  CreditCardDetailsWrapper,
  InputIconButton,
} from './styles';

const CreditCardDetails = ({
  headerText = 'Enter Payment Information',
  zipCodeLabel = 'Billing Postal Code',
  loading,
  trackOnBlurPath,
}) => {
  const {
    onBlur: onPostalCodeBlur,
    errorMessage: postalCodeErrorMessage,
    postalCodeToolTipOptions,
    zipCodeText,
  } = usePostalCodeInput({ trackOnBlurPath, zipCodeLabel });
  const {
    cardNumberProps,
    handleStripeInputBlur,
    securityCodeToolTipOptions,
    stripeInputDefaultProps,
  } = useStripeInputProps(loading, trackOnBlurPath);

  return (
    <CreditCardDetailsWrapper>
      {!!headerText && (
        <CreditCardDetailsHeader>{headerText}</CreditCardDetailsHeader>
      )}
      <CreditCardDetailsRow>
        <CreditCardDetailsInput
          autoComplete="cc-number"
          id={CARD_ID}
          InputIcon={() => (
            <InputIconButton
              type="Lock"
              boxSize="5"
              color="grey.light"
              tabIndex={-1}
            />
          )}
          label="Card Number"
          onBlur={handleStripeInputBlur('cardNumber')}
          InputElement={CardNumberElement}
          {...cardNumberProps}
        />
      </CreditCardDetailsRow>
      <CreditCardDetailsRow>
        <CreditCardDetailsInput
          autoComplete="cc-exp"
          id={EXPIRATION_DATE_ID}
          label="Expiration Date"
          onBlur={handleStripeInputBlur('cardExpiration')}
          InputElement={CardExpiryElement}
          {...stripeInputDefaultProps}
        />
        <CreditCardDetailsInput
          id={SECURITY_CODE_ID}
          label="Security Code"
          InputElement={CardCvcElement}
          onBlur={handleStripeInputBlur('cardSecurityCode')}
          toolTipOptions={securityCodeToolTipOptions}
          {...stripeInputDefaultProps}
        />
        <CreditCardDetailsInput
          autoComplete="postal-code"
          errorMessage={postalCodeErrorMessage}
          disabled={loading}
          id={POSTAL_CODE_ID}
          label={zipCodeLabel}
          InputElement={FormInput}
          onBlur={onPostalCodeBlur}
          shouldUpdateInvalid={false}
          toolTipOptions={postalCodeToolTipOptions}
          type="text"
          zipCodeText={zipCodeText}
        />
      </CreditCardDetailsRow>
    </CreditCardDetailsWrapper>
  );
};

export default CreditCardDetails;
